import React, {useState, useEffect, useContext} from 'react';
import {useSelector} from 'react-redux';
import {labels} from '../../../../util/utils';
import styled from 'styled-components';
import * as groupActiontypes from './Helper/GroupActionTypes';
import {GroupContext} from './Helper/GroupContext';
import MotifTooltip from '@ey/motif-react-wrapper/Tooltip';
import Checkbox from '../../../CoreWrappers/Checkbox';

const DashboardViews = (props) => {
	const {state, dispatch} = useContext(GroupContext);
	const isGroupEditMode = useSelector((store) => store.isGroupEditMode);
	//const initialViews = currentResource.dashboardViews;

	const initialViews = [
		{
			id: 'milestones_checkbox',
			displayName: labels.milestones,
			value: 'Milestones',
			checked: false,
			tooltipText: labels.milestonesTooltipText
		},
		{
			id: 'canvas-client_checkbox',
			displayName: labels.canvasClientPortalEy,
			value: 'Canvas Client Portal',
			checked: false,
			tooltipText: labels.canvasClientPortalTooltipText
		},
		{
			id: 'group-audit_checkbox',
			displayName: labels.groupAudit,
			value: 'Group audit',
			checked: false,
			tooltipText: labels.groudAuditTooltipText
		},
		{
			id: 'proj-mgt_checkbox',
			displayName: labels.projectManagement,
			value: 'Project management',
			checked: false,
			tooltipText: labels.projectManagementTooltipText
		},
		{
			id: 'insights_checkbox',
			displayName: labels.insights,
			value: 'Insights',
			checked: false,
			tooltipText: labels.insightsTootipText
		},
		{
			id: 'reporting_checkbox',
			displayName: labels.reporting,
			value: 'Reporting',
			checked: false,
			tooltipText: labels.reportTootipText
		}
	];

	const [views, setViews] = useState(initialViews);

	const checkboxHandler = (e) => {
		if (e !== undefined && e !== null && e !== '') {
			let newViews = [...views];
			let viewIndex = newViews.findIndex((view) => view.id === e);
			newViews[viewIndex].checked = !newViews[viewIndex].checked;
			setViews(newViews);
		}
	};

	useEffect(() => {
		if (isGroupEditMode && props.views.length > 0) {
			let newState = [...initialViews];
			newState.forEach((element) => {
				if (props.views.includes(element.value)) {
					element.checked = true;
				}
			});
			setViews([...newState]);
		}
	}, []);

	useEffect(() => {
		const filteredViews = views.filter((el) => el.checked == true);
		dispatch({type: groupActiontypes.UPDATE_VIEWS, payload: filteredViews});
	}, [views]);

	return (
		<StyledDashboardView>
			<h4>{labels.createGroupDashboardViews}</h4>
			<p>{labels.dashboardViewsSubHeading}</p>
			<ul className="checkoption-list">
				{views.map((item) => (
					<li key={`${item.id} ${item.checked}`}>
						<MotifTooltip
							placement="top"
							contentClassName="add-group-modal-tooltip"
							trigger={
								<Checkbox
									key={`${item.id}_${item.checked}`}
									styleName="checkoption-item"
									label={item.displayName}
									id={item.id}
									value={item.id}
									name={'chk_' + item.id}
									onChange={(e) => {
										checkboxHandler(e.target.id);
									}}
									checked={item.checked}
									hidetitletip
								/>
							}
						>
							{item.tooltipText}
						</MotifTooltip>
					</li>
				))}
			</ul>
		</StyledDashboardView>
	);
};

export default DashboardViews;

const StyledDashboardView = styled.div`
	width: 100%;
	ul {
		display: flex;
		margin-top: 2rem;
		flex-wrap: wrap;
		li {
			width: 30%;
			margin-bottom: 1.5rem;
			& > span {
				width: 100%;
			}
			position: relative;
			.checkoption-item {
				.motif-checkbox:hover {
					.motif-checkbox-label {
						font-weight: normal;
					}
				}
			}
		}
	}
`;
